import { useEffect } from 'react';

/**
 * Custom hook to scroll to top when component mounts or dependencies change
 * @param dependencies - Array of dependencies that trigger scroll to top
 * @param behavior - Scroll behavior ('auto' | 'smooth')
 */
export const useScrollToTop = (
  dependencies: any[] = [],
  behavior: ScrollBehavior = 'smooth'
) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior });
  }, dependencies);
};

/**
 * Custom hook to scroll to top immediately when component mounts
 */
export const useScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
}; 